import React, { useState } from 'react';
import PropTypes, { oneOf } from 'prop-types';
// import { useInView, InView } from 'react-intersection-observer';
import VideoSectionStyles from './VideoSection.styled';
import ButtonVideo from '../Shared/ButtonVideo';
import Modal from '../Shared/Modal';
import Video from '../Shared/Video';
import noop from '../../util/noop';
import VideoThumbNail from '../../../public/images/your-mortgage-phone.png';
import PlayCircleLarge from '../Shared/Icons/PlayCircleLarge';
import InView from '../../components/Shared/InView';

const VideoSection = ({
  video = null,
  title = '',
  id = null,
  columnOne = null,
  columnTwo = null,
  columnThree = null,
  children,
  isAnimated = true,
  style = null,
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handlePlayClick = handler => () => {
    setModalOpen(true);
    handler();
  };

  return (
    <InView triggerOnce='true' threshold='0.25'>
      <VideoSectionStyles id={id} style={style}>
        <div className='inner'>
          <header>
            <div className='section-wrapper'>
              <div className='title'>
                <h3>{title}</h3>
              </div>
              <div
                className='video-thumbnail'
                onClick={handlePlayClick(video.onClick || noop)}
              >
                {video && video.content && (
                  <div>
                    <div className='thumbnail-wrapper'>
                      <img src={VideoThumbNail} />
                    </div>

                    <div class='play-button'>
                      <PlayCircleLarge />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </header>
        </div>
        {modalOpen && (
          <Modal onClose={() => setModalOpen(false)}>
            <Video {...video} />
          </Modal>
        )}
      </VideoSectionStyles>
    </InView>
  );
};

VideoSection.propTypes = {
  video: PropTypes.shape({
    source: PropTypes.oneOf(['Wistia', 'fjt7qrd3s2']),
    content: PropTypes.string,
  }),
  title: PropTypes.string,
  columnOne: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  columnTwo: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  columnThree: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  isAnimated: PropTypes.bool,
};

export default VideoSection;
